module.exports = __webpack_public_path__ + "static/man_lift-f5a034632b86a96d8df57471c4496e63.svg";